import React, { FunctionComponent, useEffect, useState } from 'react'
import * as S from './styled'
import TimePeriod from '../../atoms/TimePeriod/TimePeriod'
import { Period } from '../../../pages/DashBoard/DashBoardScreen'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { MainState } from '../../../redux/reducers'
import { requestActions } from '../../../redux/requests'
import useConnectRequest from '../../../hooks/useConnectRequest'
import { GET_CUSTOM_FILTERS } from '../../../redux/requests/products/product.actions'
import { Filter } from '../../../redux/requests/products/product.types'
import { GET_USER_BY_UID } from '../../../redux/requests/auth/auth.actions'

type OwnProps = {
  showCalender: boolean
  setShowCalender: React.Dispatch<React.SetStateAction<boolean>>
  setStartDate: React.Dispatch<React.SetStateAction<Date>>
  setEndDate: React.Dispatch<React.SetStateAction<Date>>
  startDate: Date
  endDate: Date
  startDateLocal: Date
  endDateLocal: Date
  setStartDateLocal: React.Dispatch<React.SetStateAction<Date>>
  setEndDateLocal: React.Dispatch<React.SetStateAction<Date>>
  setWeeks: React.Dispatch<React.SetStateAction<number>>
  latestData: { latestStart: Date; latestEnd: Date }
}

type Props = OwnProps

export const TimePeriodBox: FunctionComponent<Props> = ({
  showCalender,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  setShowCalender,
  latestData: { latestEnd, latestStart },
}) => {
  const { data: cf } = useConnectRequest(GET_CUSTOM_FILTERS)
  const dispatch = useDispatch()
  const uid = useSelector((state: MainState) => state.misc.uid) ?? ''
  const { loading: loadingUser, data: user } = useConnectRequest(GET_USER_BY_UID)

  const [offset, setOffset] = useState(0)
  const [selectedOpt, setSelectedOpt] = useState(user?.settings?.selectedFilter ?? 3)
  const [lineX, setLineX] = useState(0)
  const [customFilters, setCustomFilters] = useState<Filter[]>([])

  useEffect(() => {
    dispatch(requestActions.products.getCustomFilters(uid!))
  }, [startDate, endDate])
  useEffect(() => {
    setCustomFilters(cf)
  }, [cf])
  useEffect(() => {
    dispatch(requestActions.auth.getUserByUid(uid))
  }, [])
  const deleteFilter = async (filterId: string) => {
    await dispatch(requestActions.products.deleteCustomFilter(uid!, filterId))
    setCustomFilters(prev => prev.filter(f => f.id !== filterId))
    setSelectedOpt(prev => prev - 1)
    setStartDate(moment().subtract(12, 'year').toDate())
    setEndDate(new Date())
  }

  const filters = [
    {
      start: startDate,
      end: endDate,
      caption: 'Senaste',
      unit: Period.LAST,
      isLifeWeek: false,
      id: '',
    },
    {
      start: startDate,
      end: endDate,
      caption: 'Månad',
      unit: Period.MONTH,
      isLifeWeek: false,
      id: '',
    },
    {
      start: startDate,
      end: endDate,
      caption: 'År',
      unit: Period.YEAR,
      isLifeWeek: false,
      id: '',
    },
    {
      start: startDate,
      end: endDate,
      caption: 'Allt',
      unit: Period.ALL,
      isLifeWeek: false,
      id: '',
    },
    ...(customFilters
      ? customFilters.map(f => ({ ...f, caption: f.caption ?? '', unit: Period.CUSTOM }))
      : []),
    {
      start: startDate,
      end: endDate,
      caption: 'Nytt filter',
      isLifeWeek: false,
      unit: Period.NEW,
      id: '',
    },
  ]
  function clickHandler(
    unit: Period,
    start: Date,
    end: Date,
    index: number,
    x: number,
    id: string,
  ) {
    switch (unit) {
      case Period.LAST:
        setStartDate(latestStart)
        setEndDate(latestEnd)
        break
      case Period.MONTH:
        setStartDate(moment().subtract(1, 'month').toDate())
        setEndDate(new Date())
        break
      case Period.YEAR:
        setStartDate(moment().subtract(1, 'year').toDate())
        setEndDate(new Date())
        break
      case Period.ALL:
        setStartDate(moment().subtract(12, 'year').toDate())
        setEndDate(new Date())
        break

      case Period.CUSTOM:
        setStartDate(start)
        setEndDate(end)
        break
      case Period.NEW:
        setShowCalender(true)

        break
    }
    dispatch(requestActions.auth.updateUserSettings(uid, { selectedFilter: index }))
    setSelectedOpt(index)
    setLineX(x)
  }
  return (
    <>
      <S.Card selected>
        {filters.map((filter, i) => (
          <TimePeriod
            selected={selectedOpt === i}
            caption={filter.caption}
            unit={filter.unit}
            showCalender={showCalender}
            startDate={filter.start}
            endDate={filter.end}
            clickHandler={clickHandler}
            index={i}
            setLineX={setLineX}
            key={i}
            id={filter.id}
            setOffset={setOffset}
            isFirst={i === 0}
            setCustomFilters={setCustomFilters}
            setSelectedOpt={setSelectedOpt}
            deleteFilter={deleteFilter}
          />
        ))}
        <S.Slider x={lineX} offset={offset} />
      </S.Card>
    </>
  )
}

export default TimePeriodBox
